import * as React from "react";
import {  useState, useEffect } from "react";
import {Box, Fab} from "@mui/material";
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import { useTheme, createTheme, ThemeProvider } from "@mui/material/styles";



export default function BackToTopFAB() {
  const btheme = useTheme();

	const theme = createTheme({
		palette: {
			primary: {
				main: btheme.palette.info.main,
			},
		},
	});
	let style = {
		marginLeft: "89%",
		position: "fixed",
    bottom: "14%",
    left: 0,
    zIndex: 999,
		"&:before, &:after": {
			marginLeft: "89%",
			position: "fixed",
      bottom: "14%",
      left: 0,
      zIndex: 999,
		},
	};
	let headerOffset = 110;
	let [showButton, setShowButton] = useState(false);
	useEffect(() => {
		window.addEventListener("scroll", () => {
			if (window.pageYOffset > headerOffset) {
				setShowButton(true);
			} else {
				setShowButton(false);
			}
		});
	}, []);

	// Function to scroll to top
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	let sx = {};
	let s = { ...style, ...sx };

	return (
		<>
			{showButton && (
				<Box sx={s} id="topfab">
          <ThemeProvider theme={theme}>
					<Fab
						color="primary"
						aria-label="topfab"
						size="medium"
						onClick={scrollToTop}
					>
						<ArrowUpwardRoundedIcon />
					</Fab>
          </ThemeProvider>
				</Box>
			)}
		</>
	);
}
